import { Spinner } from 'components';
import { GoogleAnaliticsEvent } from 'enum';
import { useBookmarkJobMutation, useJobDetailQuery, useViewJobMutation } from 'graphql/generated';
import React from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { logAnalyticsEvent } from 'ui-services/analytics.ui-service';
import { normalizeJob } from 'ui-services/job.ui-service';
import NotFound from 'views/not-found';
import { JobDetail } from './job-detail';

interface RouteParams {
    slug: string;
}

export const Job: React.FC<RouteComponentProps> = () => {
    const { slug } = useParams<RouteParams>();
    const [bookmarkJob] = useBookmarkJobMutation({
        onCompleted({
            bookmarkJob: {
                job: { id, bookmarked },
            },
        }) {
            if (bookmarked) {
                logAnalyticsEvent(GoogleAnaliticsEvent.JOB_FAVORITED, { jobId: id });
            } else {
                logAnalyticsEvent(GoogleAnaliticsEvent.FAVORITE_JOB_REMOVED);
            }
        },
    });
    const [viewJob] = useViewJobMutation();

    const { loading, error, data, refetch } = useJobDetailQuery({
        fetchPolicy: 'network-only',
        variables: { slug },
        onCompleted: (data) => viewJob({ variables: { jobId: data.job.id } }),
    });

    if (loading) {
        return <Spinner />;
    }

    if (error) {
        return <NotFound />;
    }
    if (!data) {
        return <NotFound />;
    }
    const job = normalizeJob(data);
    return <JobDetail refetch={refetch} bookmarkJob={bookmarkJob} {...job} />;
};
